const _map = {};

const modules = require.context('./', true, /[A-Z$]\/index\.js$/);

modules.keys().map((key) => {
    const name = key.split('/')[1];
    modules(key).default.key = name;
    const components = modules(key).default?.components ?? {};
    Object.values(components).forEach(x => x && (x.key = name));
    _map[name] = modules(key).default;
});

export default _map;